module.exports = __webpack_public_path__ + "static/button-invoice-emails-c45512f81802b53d5f425c970b5360db.svg";